@let paginatedItems = (urls$ | async);

<app-shared-table tableHead="solid" [columns]="urlColumns" [items]="paginatedItems?.patterns || []"
    [totalItems]="paginatedItems?.total || 0" [multiActions]="multiActions"
    (multiActionEvent)="$event.action === 'check' && openCheckModal();"
    (multiActionEvent)="$event.action === 'add' && openNewModal()"
    (multiActionEvent)="$event.action === 'delete' && deleteUrls($event.list);"
    (singleActionEvent)="$event.action === 'verify' && openVerifyModal()" [pageSize]="pagination.pageSize"
    [currentPage]="pagination.page" (pageChange)="updatePagination($event)" (sortChange)="updateSort($event);"
    [isLoading]="loading" [clickableRow]="false" [tableHeightElems]="4">

    <div class="d-flex flex-wrap align-items-center gap-2 bg-white rounded-2 p-3" [class.mt-3]="paginatedItems?.patterns?.length === 0">

        <span>Sitemap:</span>

        @for (sitemap of sitemaps(); track sitemap.id) {
        <span class="badge rounded-2 px-3 py-2 d-inline-flex align-items-center text-primary fw-normal"
            style="background-color: #E3E7F4;">
            {{ sitemap.sitemap }}

            <button type="button" class="btn-close ms-2" style="font-size: 0.6rem;"
                (click)="removeSitemap(sitemap.id); $event.stopPropagation()"></button>
        </span>
        }

        @if(sitemapLoading) {
        <span class="text-muted">Caricamento sitemap...</span>
        } @else if (sitemaps().length === 0) {
        <span class="text-muted">Nessuna sitemap associata</span>
        }

        <!-- Input + bottone inline -->
        <div class="d-flex align-items-center">
            <button class="btn btn-link btn-sm" (click)="addSitemap()">
                Aggiungi
            </button>
        </div>

    </div>

</app-shared-table>